<div
  class="sidebar shadow d-flex flex-column flex-shrink-0 justify-content-between bg-white"
  *ngIf="userService.isAuthenticated() && userService.isActive()"
  [class.expanded]="isExpanded()"
>
  <section class="navigation-section">
    <div class="text-center mb-5 mt-3">
      <label class="burger" for="burger">
        <input type="checkbox" id="burger" (click)="toggleSidebar()"/>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
      </label>
    </div>
    <ul class="nav nav-pills flex-column mb-auto text-center">
      <app-nav-link
        *ngFor="let item of visibleNavItems"
        [title]="item.title"
        [icon]="item.icon"
        [link]="item.link"
        [isActive]="isCurrentUrl(item.activePath)"
        [isExpanded]="isExpanded()"
        [activeColor]="item.activeColor ? item.activeColor : '#198AE3'"
      ></app-nav-link>
    </ul>
  </section>
  <section class="app-version d-flex justify-content-center pb-1">
    <div class="nav nav-app-verison">
      V {{ environment.appVersion }}
    </div>
  </section>
</div>
